import { useDispatch, useSelector } from 'react-redux'
import type { AppDispatch } from '../index'
import type { RootState } from '../slices/reducers'
import {
  getAllLandFavorites,
  createLandFavorite,
  getLandFavoriteById,
  getLandFavoritesByLandId,
  deleteLandFavorite,
  clearError,
  clearFavorites,
} from '../slices/favoritesSlice'
import type { CreateLandFavoriteRequest } from '@popety-io/types'

export const useLandsFavorites = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { favorites, loading, error } = useSelector(
    (state: RootState) => state.favorites
  )

  const actions = {
    getAllLandFavorites: () => dispatch(getAllLandFavorites()),
    createLandFavorite: (favoriteData: CreateLandFavoriteRequest) =>
      dispatch(createLandFavorite(favoriteData)),
    getLandFavoriteById: (id: string) => dispatch(getLandFavoriteById(id)),
    getLandFavoritesByLandId: (landId: string) =>
      dispatch(getLandFavoritesByLandId(landId)),
    deleteLandFavorite: (id: string) => dispatch(deleteLandFavorite(id)),
    clearError: () => dispatch(clearError()),
    clearFavorites: () => dispatch(clearFavorites()),
  }

  const selectors = {
    getFavoriteByLandId: (landId: string) =>
      favorites.find((fav) => fav.land_id === String(landId) && fav.active),
    isLandFavorited: (landId: string) =>
      favorites.some((fav) => fav.land_id === String(landId) && fav.active),
    getFavoritesByUserId: (userId: string) =>
      favorites.filter((fav) => fav.user_id === userId && fav.active),
    getSharedFavorites: () =>
      favorites.filter((fav) => fav.shared && fav.active),
  }

  return {
    // State
    favorites,
    loading,
    error,
    // Actions
    ...actions,
    // Selectors
    ...selectors,
  }
}
